import { useEffect, useState } from 'react';

import { useGetUserRole } from '@/hooks/identity/useGetUserRole';
import InitialSpinner from '@/components/common/InitialSpinner/InitialSpinner';
import NotAuthorized from '@/pages/NotAuthorized/NotAuthorized';
import { UserRole } from '@/config/roles.config';

interface IUserRoleLoaderProps {
  children: any;
}

export default function UserRoleLoader({ children }: IUserRoleLoaderProps) {
  const { getUserRole, isLoadingUserRole, apiWasAlreadyCalled } = useGetUserRole();
  const [userRole, setUserRole] = useState<UserRole>();

  useEffect(() => {
    const getRole = async () => { 
      const roleName = await getUserRole();
      setUserRole(roleName);
    };
  
    getRole();
  }, [getUserRole]);

  if (isLoadingUserRole) {
    return (
      <InitialSpinner />
    );
  }

  if (apiWasAlreadyCalled && !userRole) {
    return (
      <NotAuthorized
        text="You are not authorized to view this application"
        withBreadcrumbsOffset={false}
      />
    );
  }

  if (!userRole) {
    return <></>;
  }

  return children;
}
